import {Component, Inject, OnInit} from '@angular/core';
import {Carteira} from "../carteira.model";
import {FormControl, FormGroup} from "@angular/forms";
import {MaskUtil} from "../../shared/util/mask-util";
import {MAT_DIALOG_DATA, MatDialog} from "@angular/material/dialog";
import {CarteiraService} from "../carteira.service";

@Component({
    template: `

  `,
    selector: 'app-carteira-detalhe'
})
export class CarteiraDetalheComponent implements OnInit {

    constructor(public dialog: MatDialog) {
    }

    ngOnInit() {
    }

    openDialog(carteira: Carteira, readOnly: boolean) {
        const dialogRef = this.dialog.open(CarteiraEditDialogComponent, {
            data: carteira,
            width: '1200px',
            autoFocus: false
        });

        dialogRef.componentInstance.readonly = readOnly;
    }
}

@Component({
    selector: 'carteira-edit-dialog',
    templateUrl: 'carteira-edit-dialog.html'
})
export class CarteiraEditDialogComponent {

    constructor(@Inject(MAT_DIALOG_DATA) public carteira: Carteira, private carteiraService: CarteiraService) {
        this.form = new FormGroup({
            auto: new FormControl(carteira.auto),
        });
    }

    form: FormGroup;
    formatCnpj = MaskUtil.formatCnpj;
    readonly = false;

    save() {
        const previousVal = this.carteira.auto;

        this.carteira.auto = this.form.value.auto;
        this.carteiraService.update(this.carteira).subscribe(data => {
            this.carteira.auto = data.auto;
        }, error => {
            this.carteira.auto = previousVal;
            alert(error);
        });
    }
}
